import { render } from "./ErrorClientCallBlock.vue?vue&type=template&id=6bfb28df"
import script from "./ErrorClientCallBlock.vue?vue&type=script&lang=js"
export * from "./ErrorClientCallBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__